export default "/images/package.svg?52c71e7e25da7968262e5699db9efaf3";